export default "__VITE_ASSET__540b6b5a__"